import React, { Fragment, PureComponent } from 'react';
import { DataSource } from '~/Api/DataSource';
import { ProductPrice as ProductPriceEntity } from '~/Product';

import LicenseProvider from './LicenseProvider';

interface Props {
	dataSource: DataSource | null;
	productPrice: ProductPriceEntity | null;
	rounded: boolean;
	isFetching: boolean;
	emptyValue: React.ReactNode;
}

export default class ProductPrice extends PureComponent<Props> {
	static defaultProps = {
		productPrice: null,
		rounded: false,
		emptyValue: 'N/A',
	};

	render() {
		const { dataSource, productPrice, rounded, isFetching, emptyValue } = this.props;

		if (!dataSource) {
			return null;
		}

		return (
			<LicenseProvider dataSource={dataSource}>
				{(isLicenced) => {
					if (isLicenced === null) {
						return null;
					}
					if (dataSource.requiresLicence.prices && !isLicenced) {
						return (
							<Fragment>
								restricted
								<br />
								in trial
							</Fragment>
						);
					}
					if (!productPrice || !productPrice.price) {
						return <>{isFetching ? null : emptyValue}</>;
					}
					return rounded ? productPrice.price.roundedHumanFormat() : productPrice.price.humanFormat();
				}}
			</LicenseProvider>
		);
	}
}
